import localStorage from "../../../utilities/localStorage";

const CONSENT_KEY = "cookie_consent";

export const isCookieConsent = () => {
    return getCookieConsent() !== null;
};

export const getCookieConsent = () => {
    return localStorage.getItem(CONSENT_KEY);
};

export const setCookieConsent = value => {
    localStorage.setItem(CONSENT_KEY, value);
};